import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Video from 'react-jw-player';
import Slug from '../slug/slug';
import AdTagGenerator from '../video_module/utils/video_module_ads';

export default class VideoReactJW extends Component {
  constructor() {
    super();
    this.generatePreRoll = this.generatePreRoll.bind(this);
  }

  generatePreRoll() {
    const { data, type } = this.props;

    return new AdTagGenerator(
      get(data, 'title'),
      type,
      'preroll_rightrail',
      null,
      'reactjwplayer'
    ).adTag;
  }

  render() {
    const { playerid, playlistId } = this.props;

    return (
      <div className="siderail-video-module">
        <Slug slugName={this.props.slugName} className="column" />
        <div className="siderail-video-module__player-container">
          <Video
            playerId={playerid}
            playerScript={`https://content.jwplatform.com/libraries/${
              playerid
            }.js`}
            playlist={`//content.jwplatform.com/feeds/${playlistId}.json`}
            generatePrerollUrl={this.generatePreRoll}
            playInView={true}
            isMuted={true}
            isAutoPlay={false}
            playInViewPercentage={100}
            aspectRatio="16:9"
          />
        </div>
        {/* <h3 className="card__title card__title--small siderail-video-module__player-title-slug">
          {this.state.activeTitle}
        </h3> */}
      </div>
    );
  }
}

VideoReactJW.defaultProps = {
  data: {},
  slugName: 'Featured Video'
};

VideoReactJW.propTypes = {
  data: PropTypes.shape({}),
  playerid: PropTypes.string.isRequired,
  playlistId: PropTypes.string.isRequired,
  slugName: PropTypes.string,
  type: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/views/components/siderail_video_module/siderail_video_module_reactjw.js